var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import DateAndTimePicker from '@declaration/components/UI/DateAndTimePicker.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { formatDateTime, isValidDate } from '@shared/utils/date';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyLeaveDateQuestion = class RobberyLeaveDateQuestion extends QuestionComponent {
    get value() {
        var _a, _b;
        return ((_b = (_a = this.qualification) === null || _a === void 0 ? void 0 : _a.absenceDateTimeInterval) === null || _b === void 0 ? void 0 : _b.start)
            ? new Date(this.qualification.absenceDateTimeInterval.start)
            : null;
    }
    set value(val) {
        var _a, _b;
        this.updateQualification({
            qualificationPayload: {
                absenceDateTimeInterval: {
                    start: val ? val.toISOString() : null,
                    end: (_b = (_a = this.qualification.absenceDateTimeInterval) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : null,
                },
            },
        });
    }
    onValidation() {
        var _a, _b, _c, _d, _e;
        if (!this.canValidate)
            return;
        this.updateAndSaveQualification({
            step: this.step,
            qualificationPayload: {
                absenceDateTimeInterval: {
                    start: (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.toISOString()) !== null && _b !== void 0 ? _b : null,
                    end: (_e = (_d = (_c = this.qualification.absenceDateTimeInterval) === null || _c === void 0 ? void 0 : _c.start) !== null && _d !== void 0 ? _d : this.claim.damageDate) !== null && _e !== void 0 ? _e : new Date().toISOString(),
                },
            },
        });
    }
    get maxDate() {
        var _a, _b;
        const endDate = (_b = (_a = this.qualification.absenceDateTimeInterval) === null || _a === void 0 ? void 0 : _a.start) !== null && _b !== void 0 ? _b : this.claim.damageDate;
        if (!endDate)
            return new Date();
        return new Date(Math.min(Date.parse(endDate), Date.now()));
    }
    get canValidate() {
        return isValidDate(this.value, { max: this.maxDate });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.leave_date.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.leave_date.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.value)
            return null;
        return this.$tc('claim.qualification.robbery.leave_date.answer', 0, {
            date: formatDateTime(this.value, this.$i18n.locale),
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyLeaveDateQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claim')
], RobberyLeaveDateQuestion.prototype, "claim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyLeaveDateQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyLeaveDateQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], RobberyLeaveDateQuestion.prototype, "updateQualification", void 0);
RobberyLeaveDateQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiButton, DateAndTimePicker },
        props: QuestionProps,
    })
], RobberyLeaveDateQuestion);
export default RobberyLeaveDateQuestion;
